import styled from 'styled-components';
import { layout } from '@prisjakt/ui-base';

export const FiltersDesktop = styled.div`
  display: flex;
  width: fit-content;
  gap: 0.5rem;
`;

export const AppliedFiltersWrapper = styled.div`
  margin: ${layout.measurements.spacing050};
`;
